import React from 'react';

interface IChatBotWindowProps {
    children: React.ReactNode;
}

export const ChatBotWindow: React.FC<IChatBotWindowProps> = ({ children }) => {
    return <div className="chat-bot">{children} </div>;
};
